import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PortfolioTransactions } from 'clientportalshared';
import { ScreenState } from '@enums/index';
import { DateRange } from '../..';
import { getTransactionsAsync } from './thunks';
import { DateTime } from 'luxon';
import { UpdateTransactionFilter } from './types';
import { DatePickerNames } from '@components/dateRange/DateRangePreDefinedDates';

export interface TransactionsStore {
  state: ScreenState;
  error?: string;
  data: PortfolioTransactions;
  dateRange: DateRange;
  filteredIds: number[];
  filteredItem: string;
}

const initialState: TransactionsStore = {
  dateRange: {
    dateFrom: DateTime.now().minus({ months: 12 }).toISODate(),
    dateTo: DateTime.now().toISODate(),
    dateRangeType: DatePickerNames.Last12Months,
  },
  state: ScreenState.Loading,
} as TransactionsStore;

export const TransactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    setTransactionsFilter: (state, action: PayloadAction<UpdateTransactionFilter>) => {
      state.filteredIds = [...action.payload.ids];
      state.filteredItem = action.payload.name;
    },
    setTransactionDataRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getTransactionsAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(getTransactionsAsync.rejected, (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    });
    builder.addCase(getTransactionsAsync.fulfilled, (state, action: PayloadAction<PortfolioTransactions>) => {
      state.state = ScreenState.SuccessDataLoaded;
      state.data = action.payload;
    });
  },
});

export const { setTransactionsFilter, setTransactionDataRange } = TransactionsSlice.actions;

export default TransactionsSlice.reducer;
